<template>
    <div>
        <van-sticky>
            <div class="top-back">
                <div class="top-info">
                <div class="top-info-left">
                    <van-image class="logo"
                        fit="contain" @click="scroll('tabi')"
                        src="/img-new/booboolink.png"
                    />
                </div>
                <el-menu class="top-info-right" style="border-bottom-width: 0px;" mode="horizontal">
                    <el-menu-item @click="scroll('kaisya')" index="1">
                        <span class="top-info-right-font">会社情報</span>
                    </el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">
                            <span class="top-info-right-font">商品紹介</span>
                        </template>
                        <el-menu-item @click="scroll('tabi')" index="2-1">
                            <span class="top-info-right-font">タピブーブー</span>
                        </el-menu-item>
                        <el-menu-item @click="scroll('izaka')" index="2-2">
                            <span class="top-info-right-font">イザカブーブー</span>
                        </el-menu-item>
                        <el-menu-item @click="scroll('serufu')" index="2-3">
                            <span class="top-info-right-font">セルフブーブー</span>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item @click="scroll('contact')" index="3">
                        <span class="top-info-right-font">お問い合わせ</span>
                    </el-menu-item>
                </el-menu>
                </div>
            </div>
            <!--<div class="btn-back" id="top">
                <van-row type="flex" justify="space-around">
                    <van-col span="8">
                        <div @click="scroll('tabi')">
                            <van-image
                                class="top-btn"
                                fit="contain"
                                src="/img-new/btn-tabi-icon.png"
                            />
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div @click="scroll('izaka')">
                            <van-image
                                class="top-btn"
                                fit="contain"
                                src="/img-new/btn-izaka-icon.png"
                            />
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div @click="scroll('serufu')">
                            <van-image
                                class="top-btn"
                                fit="contain"
                                src="/img-new/btn-serufu-icon.png"
                            />
                        </div>
                    </van-col>
                </van-row>
            </div>-->
        </van-sticky>
        <div class="defWid">
            <div>
                <div id="tabi" class="scroll"/>
                <van-row>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/img-main-tabi.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/img-tabi.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/info-tabi.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/price-tabi.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/person-tabi.png"
                        />
                    </van-col>
                    <van-col span="24" class="mv-container">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/mv-tabi-back.png"
                        />
                        <iframe class="mv-hard" src="https://www.youtube.com/embed/vONFp2Ssvkw" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </van-col>
                </van-row>
            </div>
            <div>
                <div id="izaka" class="scroll"/>
                <van-row>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/img-main-izaka.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/img-izaka.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/info-izaka.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/price-izaka.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/person-izaka.png"
                        />
                    </van-col>
                    <van-col span="24"  class="mv-container">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/mv-izaka-back.png"
                        />
                        <iframe class="mv-hard" src="https://www.youtube.com/embed/tTv8Y4CUGvc" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </van-col>
                </van-row>
            </div>
            <div>
                <div id="serufu" class="scroll"/>
                <van-row>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/img-serufu-waiting.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/price-serufu.png"
                        />
                    </van-col>
                    <van-col span="24">
                        <van-image
                            class="dis-blk"
                            height="100%"
                            fit="contain"
                            src="/img-new/person-serufu.png"
                        />
                    </van-col>
                </van-row>
            </div>
            <div id="bot">
                <div class="margin-bot-info"/>
                <van-row type="flex" justify="space-around">
                    <van-col span="12">
                        <div class="margin-bot-info"/>
                        <span class="bot-qr-font">
                            タピブーブー体験版
                        </span><br>
                        <div class="margin-bot-info"/>
                        <van-image
                            width="50%"
                            fit="contain"
                            src="/img-new/tabi-qr.png"
                        />
                    </van-col>
                    <van-col span="12">
                        <div class="margin-bot-info"/>
                        <span class="bot-qr-font">
                            いざかブーブー体験版
                        </span><br>
                        <div class="margin-bot-info"/>
                        <van-image
                            width="50%"
                            fit="contain"
                            src="/img-new/izaka-qr.png"
                        />
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="24">
                        <div class="margin-bot-top"/>
                        <div id="kaisya" class="scroll"/>
                        <div style="width: 66%; max-width: 1200px; margin: 2rem auto; padding: 2rem 0">
                            <van-row class="kaisya-global-body">
                                <span class="kaisya-global-title">会社概要</span>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">会社名</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">ブーブーリンク株式会社</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">所在地</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">東京都豊島区池袋二丁目36番1号8F-39</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">設立</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">令和1年11月28日</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">資本金</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">5,000,000円</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">取締役</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">代表取締役社長&nbsp;鐘&nbsp;&nbsp;&nbsp;攀</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">電話番号</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">03-3983-0588</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">メールアドレス</span>
                                </van-col>
                                <van-col span="17">
                                    <span class="kaisya-info-font">syouhan@booboolink.co</span>
                                </van-col>
                            </van-row>
                            <van-row class="kaisya-info-form">
                                <van-col span="7">
                                    <span class="kaisya-title-font">事業内容</span>
                                </van-col>
                                <van-col span="17">
                        <span class="dis-inblk kaisya-info-font">
                            システム導入<br>
                            ○飲食店：タピブーブー注文システム/いざかブーブーブーブー注文システム
                            <br><br><br>
                            アプリケーション・ソフトウェア業務受注<br>
                            ○サービス：注文／POS／会員管理／決済<br>
                            ○流通：受注売上管理／在庫管理<br>
                            ○共通：勤怠打刻
                            <br><br><br>
                            その他業務受注<br>
                            ○飲食店向け電子サイネージ、ポスターのデザイン<br>
                        </span>
                                </van-col>
                            </van-row>
                        </div>
                    </van-col>
                </van-row>
                <div>
                    <div id="contact" class="scroll"/>
                    <div class="margin-bot-top" style="margin: 1rem 0"/>
                    <van-row>
                        <van-col span="24">
                            <div class="bot-back">
                                <van-image
                                    class="bot-contact-info"
                                    fit="contain"
                                    src="/img-new/contact-info.png"
                                />
                            </div>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col class="contact-global-body" span="24">
                            <span class="contact-global-title">お問い合わせ</span>
                        </van-col>
                    </van-row>
                    <div  class="contact-back">
                        <contact/>
                    </div>
                    <div class="contact-bot"/>
                </div>
                <div class="global-page-bot"/>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import { Row, Col, Image, Button, Icon, Sticky } from 'vant'
    import { Menu } from 'element-ui'
    import Contact from './Contact'

    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Image)
    Vue.use(Button)
    Vue.use(Icon)
    Vue.use(Sticky)
    Vue.use(Menu)

    export default {
        name: 'newhome',
        components: {Contact},
        data () {
            return {

            }
        },
        methods: {
            scroll (divId) {
                document.querySelector("#" + divId).scrollIntoView(true);
            }
        },

    }

</script>

<style>
    /* val = i6 */
    .top-info {
        width: 90%;
        margin: 0 auto;
        padding: 8px 0
    }
    .top-info-left {
        width: 80%;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    .top-info-right-font {
        font-size: 12px;
    }
    .margin-bot-info {
        height: 0.1rem;
        margin-top: 0.15rem;
        margin-bottom: 0.15rem;
    }
    .bot-back {
        margin: 1rem auto;
        height: 3.5rem;
    }
    .bot-contact-info {
        width: 75%;
        margin-top: 0.2rem;
    }
    .top-btn {
        width: 80%;
        height: 100%;
    }
    .bot-qr-font {
        font-size: 0.8rem;
    }
    .margin-bot-top {
        height: 0.1rem;
        margin-top: 0.8rem;
    }
    .scroll {
        position: relative;
        top: -112px;
    }

    .kaisya-global-body {
        margin-bottom: 1.5rem;
    }

    .kaisya-global-title {
        font-size: 1rem;
        font-weight: 700;
        border-bottom: 1px solid #222222;
    }

    .kaisya-info-form {
        text-align: left;
        margin: 0.6rem 0;
    }

    .kaisya-title-font {
        font-size: 0.6rem;
    }

    .kaisya-info-font {
        font-size: 0.55rem;
    }

    .contact-global-body {
        margin-bottom: 1.8rem;
    }

    .contact-global-title {
        font-size: 1rem;
        font-weight: 700;
        border-bottom: 1px solid #222222;
    }

    .logo {
        margin: 0 auto;
        height: 4rem;
        border-bottom: 1px solid #222222;
    }


    /* iphone 5 */
    @media screen and (max-width: 320px) {
        .top-info-left {
            width: 85%;
            margin: 0 auto;
        }
        .bot-back {
            height: 3.5rem;
        }
        .bot-contact-info {
            width: 75%;
            margin-top: 0.2rem;
        }

        .kaisya-title-font {
            font-size: 0.6rem;
        }

        .kaisya-info-font {
            font-size: 0.6rem;
        }
    }

    /* val = iX */
    @media screen and (min-width: 375px) and (-webkit-device-pixel-ratio: 3) {
        .kaisya-title-font {
            font-size: 0.65rem;
        }

        .kaisya-info-font {
            font-size: 0.65rem;
        }
    }

    /* val = i6p */
    @media screen and (min-width: 414px) {
        .top-info-left {
            width: 80%;
            margin: 0 auto;
        }
        .margin-bot-info {
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
        }
        .top-info-right-font {
            font-size: 15px;
        }
        .bot-qr-font {
            font-size: 1rem;
        }
        .kaisya-global-body {
            margin-bottom: 2rem;
        }
        .kaisya-info-form {
            margin: 0.8rem 0;
        }
        .kaisya-global-title {
            font-size: 1.2rem;
        }
        .kaisya-title-font {
            font-size: 0.72rem;
        }

        .kaisya-info-font {
            font-size: 0.7rem;
        }

        .contact-global-title {
            font-size: 1.2rem;
        }

    }

    /* val = ipad */
    @media screen and (min-width: 768px) {
        .scroll {
            top: -93px;
        }
        .top-info {
            max-width: 1200px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 1rem 0
        }
        .margin-bot-info {
            margin-top: 0.4rem;
            margin-bottom: 0.4rem;
        }
        .bot-back {
            height: 6rem;
        }
        .bot-contact-info {
            margin-top: 0rem;
        }
        .top-btn {
            width: 50%;
            height: 80%;
        }
        .bot-qr-font {
            font-size: 1.5rem;
        }
        .margin-bot-top {
            margin-top: 1.2rem;
        }
        .kaisya-global-body {
            margin-bottom: 2.5rem;
        }
        .kaisya-global-title {
            font-size: 1.5rem;
            border-bottom: 2px solid #222222
        }
        .kaisya-info-form {
            margin: 1rem 0;
        }
        .kaisya-title-font {
            font-size: 0.85rem;
        }

        .kaisya-info-font {
            font-size: 0.75rem;
        }

        .contact-global-body {
            margin-bottom: 2.5rem;
        }

        .contact-global-title {
            font-size: 1.5rem;
            border-bottom: 2px solid #222222;
        }

        .logo {
            border-bottom: 0px;
            height: 5.5rem;
            width: 5.5rem;
            margin: 0 0;
        }
    }

    /* val = ipadp */
    @media screen and (min-width: 1024px) {
        .scroll {
            top: -112px;
        }
        .top-info {
            max-width: 1200px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 1.5rem 0
        }
        .margin-bot-info {
            margin-top: 0.45rem;
            margin-bottom: 0.45rem;
        }
        .bot-back {
            height: 8rem;
        }
        .bot-contact-info {
            margin-top: 0rem;
        }
        .top-btn {
            width: 50%;
            height: 80%;
        }
        .bot-qr-font {
            font-size: 1.6rem;
        }
        .margin-bot-top {
            margin-top: 2.8rem;
        }
        .kaisya-global-body {
            margin-bottom: 3rem;
        }
        .kaisya-global-title {
            font-size: 1.8rem;
        }
        .kaisya-info-form {
            margin: 1.2rem 0;
        }

        .kaisya-title-font {
            font-size: 1rem;
        }

        .kaisya-info-font {
            font-size: 0.8rem;
        }

        .contact-global-body {
            margin-bottom: 2.7rem;
        }

        .contact-global-title {
            font-size: 1.8rem;
        }
    }

    /* val = pc */
    @media screen and (min-width: 1100px) {
        .icon {
            width: 2rem;
            height: 2rem;
        }
        .margin-bot-info {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
        .bot-back {
            height: 10rem;
        }
        .bot-contact-info {
            margin-top: 0rem;
        }
        .top-btn {
            width: 40%;
            height: 60%;
        }
        .bot-qr-font {
            font-size: 2rem;
        }
        .margin-bot-top {
            margin-top: 3.5rem;
        }
        .kaisya-global-body {
            margin-bottom: 3.5rem;
        }
        .kaisya-global-title {
            font-size: 2rem;
        }
        .kaisya-info-form {
            margin: 1.5rem 0;
        }
        .kaisya-title-font {
            font-size: 1.3rem;
        }

        .kaisya-info-font {
            font-size: 1.1rem;
        }

        .contact-global-body {
            margin-bottom: 3rem;
        }
        .contact-global-title {
            font-size: 2rem;
        }
    }
    /* 不同分辨率下不变的样式 */
    /* 整个页面宽度 */
    .defWid {
        width: 90%;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        color: #222222;
        letter-spacing: 5px;
    }
    /* 按钮背景图片 */
    .btn-back {
        background-image: url('/img-new/btn-back.png');
        border-bottom: 1px solid #cacaca
        /* position: fixed;
        width: 90%;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        z-index: 200 */
    }
    .visiable-hidden{
        visibility: hidden;
    }
    .mv-container {
        position: relative;
    }
    .mv-hard {
        position: absolute;
        left: 22.9%;
        top: 24%;
        width: 54.2%;
        height: 62.1%;
    }
    .top-back {
        width: 100%;
        background-color: #FFFFFF;
        border-bottom: 1px solid #cacaca;
    }
    .top-info-right {
        display: flex;
        justify-content: space-around;
    }
    .dis-blk {
        display: block;
    }
    .dis-inblk {
        display: inline-block;
    }
    .contact-back {
        background-image: url('/img-new/contact-back.png')
    }

    .global-page-bot {
        height: 4rem;
    }

    .contact-bot {
        height: 1.5rem;
    }

</style>
